import api from '@/lib/api';
import type { HouseInventoryGrid } from './frontdeskOps.types';

export interface HouseInventoryQuery {
  propertyId: string;
  from: string;
  to: string;
}

export async function fetchHouseInventory(
  query: HouseInventoryQuery,
): Promise<HouseInventoryGrid> {
  const { data } = await api.get<HouseInventoryGrid>('/house-inventory', { params: query });
  return data;
}
